'use client';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';

export const BaseSkeleton = styled(Skeleton)();
